function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { createRef } from 'react';
import Stickyfill from 'stickyfilljs';
import throttle from '../utils/throttle';
var Sticky = /*#__PURE__*/function (_React$Component) {
  _inherits(Sticky, _React$Component);
  function Sticky(props) {
    var _this;
    _classCallCheck(this, Sticky);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sticky).call(this, props));
    _this.Sticky = void 0;
    _this.stickyRef = void 0;
    _this.resizeHandler = void 0;
    _this.stickyRef = createRef();
    _this.resizeHandler = throttle(_this.calculateTop.bind(_assertThisInitialized(_this)), 50);
    return _this;
  }
  _createClass(Sticky, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.stickyRef.current) {
        this.stickyRef.current.setAttribute('data-sticky', '');
      }
      window.addEventListener('resize', this.resizeHandler, false);
      this.calculateTop();

      // Edge can report the wrong position from getBoundingClientRect, so after
      // mount we want to trigger a resize again so we can try to get accurate
      // results from Edge
      setTimeout(function () {
        var event = document.createEvent('HTMLEvents');
        event.initEvent('resize', true, false);
        window.dispatchEvent(event);
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.stickyRef.current) {
        Stickyfill.removeOne(this.stickyRef.current);
        this.Sticky = null;
      }
      this.resizeHandler.cancel();
      window.removeEventListener('resize', this.resizeHandler);
    }
  }, {
    key: "calculateTop",
    value: function calculateTop() {
      if (!this.props.sticksTo) {
        return;
      }
      var el = document.querySelector(this.props.sticksTo);
      var stickyEl = this.stickyRef.current;
      if (el && stickyEl) {
        // need to remove stickyfill on the element so we can set the top without Stickyfill messing
        // with it. see: https://github.com/wilddeer/stickyfill/issues/80
        Stickyfill.removeOne(stickyEl);
        // ideally this would be handled by state, but the vagaries of stickyfill and the setState
        // callback make this difficult, and stickyfill is already mucking with our DOM node,
        // so why not lean in ¯\_(ツ)_/¯
        stickyEl.style.top = Sticky.getTopPositioning(el, this.props.adjust) + 'px';
        this.Sticky = Stickyfill.addOne(stickyEl);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.stickyRef);
    }
  }]);
  return Sticky;
}(React.Component);
Sticky.defaultProps = {
  adjust: 0
};
Sticky.getTopPositioning = function (el, adjust) {
  var _el$getBoundingClient = el.getBoundingClientRect(),
    bottom = _el$getBoundingClient.bottom,
    top = _el$getBoundingClient.top;
  if (Math.ceil(bottom) === window.innerHeight) {
    return window.innerHeight - top + adjust;
  } else {
    return (Math.abs(bottom) === bottom ? bottom : bottom + window.pageYOffset) + adjust;
  }
};
export { Sticky as default };